import { Button, Dropdown, LabelComponent, Stack, StandardCheckbox } from 'components';
import { useState } from 'react';
import { noteTypeData, setNoteType } from 'store/clients/clientsSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

type Props = {
  startRecording: ({ noteType }: { noteType: string }) => void;
  initializing: boolean;
};

const IdleScreen = ({ startRecording, initializing }: Props) => {
  const dispatch = useAppDispatch();
  const { noteType } = useAppSelector((s) => s.clients.aiScribe);
  const [consent, setConsent] = useState<boolean>(false);

  return (
    <Stack
      mt="128px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyItems="center"
      justifyContent="center"
      width="100%"
    >
      <Stack px="24px" width="100%">
        <LabelComponent text="Note Type" />
        <Dropdown
          disableAutoFocus
          smallDropdown
          withGradient
          label="Select"
          data={noteTypeData}
          onChange={(e) => {
            dispatch(setNoteType(e.target.value as string));
          }}
          name="noteType"
          id="noteType"
          value={noteType ?? ''}
        />
      </Stack>
      <Stack mt="72px" mb="20px">
        <StandardCheckbox
          label="This client is OK with being recorded"
          value={consent}
          onChange={(e) => setConsent(e.target.checked)}
        />
      </Stack>
      <Stack width="176px">
        <Button
          handleOnClick={() => startRecording({ noteType: noteType ?? '' })}
          text="Record"
          icon={<span className="material-icons">mic</span>}
          theme="primary"
          size="large"
          disabled={!consent || initializing}
        />
      </Stack>
    </Stack>
  );
};

export default IdleScreen;
